import React, {useState} from "react";
import {Dropdown, DropdownButton} from "react-bootstrap";
import {Redirect} from "react-router-dom";
import {Link} from "react-router-dom";

function DropdownOrgs(props: { orgs: any, selectedOrg: any }) {
  const {orgs, selectedOrg} = props;
  const currentPath = selectedOrg ? `/org/${selectedOrg.id}/villas` : '/my/villas';
  const [redirectToPath, setRedirectToPath] = useState(currentPath);

  function ellipsis(name: string) {
    if (name.length > 25) {
      return `${name.substr(0, 25)}…`;
    }
    return name;
  }

  const items = orgs.map((org: any) => {
      const path = `/org/${org.id}/villas`;
      return (
        <Dropdown.Item key={path} onClick={() => setRedirectToPath(path)}>
          {ellipsis(org.name)}
        </Dropdown.Item>
      );
    }
  );

  const name = selectedOrg ? ellipsis(selectedOrg.name) : "My Villas";
  const permissionAddTeam = !!selectedOrg?.scopes.find((scope: string) => scope === "org_user_member");

  if (redirectToPath !== currentPath) {
    return <Redirect to={redirectToPath}/>
  }

  const newTeam = permissionAddTeam ?
    <Dropdown.Item key="create_team" onClick={() => setRedirectToPath(`/org/${selectedOrg.id}/team/new`)}>
      New Villa…
    </Dropdown.Item>
    : null;

  const viewSelectedOrg = selectedOrg ?
    <div className="w-100">
      <Link to={`/org/${selectedOrg.id}`}>View Org</Link>
    </div>
    : null;

  return (
    <div className="row flex-nowrap align-items-end align-items-baseline">
      {viewSelectedOrg}
      <div className="col">
        <Dropdown onClick={(e: any)=> e.stopPropagation()}>
          <DropdownButton menuAlign="right" title={name}>
            {items}
            <Dropdown.Divider/>
            <Dropdown.Item key="my" onClick={() => setRedirectToPath('/my/villas')}>
              My Villas
            </Dropdown.Item>
            <Dropdown.Divider/>
            {newTeam}
            <Dropdown.Item key="create_org" onClick={() => setRedirectToPath('/org/new')}>
              New Organization…
            </Dropdown.Item>
          </DropdownButton>
        </Dropdown>
      </div>
    </div>
  );
}

export default DropdownOrgs;
